import { modelTypeMap } from '../../../constants';
import { request } from '@shakkerai/services';
import { v4 } from 'uuid';

export const getCollectData = async (modelType, collectType) => {
  try {
    const res = await request('/api/www/model/tool/like/list', {
      modelType: modelTypeMap[modelType],
      page: 1,
      pageSize: 100, // 该参数不起作用
      requestId: v4(),
      sort: collectType,
    });
    if (res.code === 0) {
      return res.data.map((r) => ({ ...r, isLike: 1 })); // 收藏接口的isLike自己处理
    } else {
      return [];
      console.log('接口异常');
    }
  } catch (err) {
    return [];
    console.log(err);
  }
};
